var NotificationLevel;
(function (NotificationLevel) {
    NotificationLevel["ERROR"] = "error";
    NotificationLevel["INFORMATION"] = "information";
    NotificationLevel["WARNING"] = "warning";
})(NotificationLevel || (NotificationLevel = {}));
export { NotificationLevel, };
//# sourceMappingURL=notification-service-types.js.map